import Immutable from "immutable";
import { floatToMoney } from "lib/money";

export const Installment = new Immutable.Record({
  number: undefined,
  price: undefined,
  paidPrice: undefined,
  outstandingPrice: undefined,
  selectedPrice: undefined,
  dueDate: undefined
}, "Installment");

function buildInstallmentFromAppserver(rawInstallment, installmentNumber) {
  return Installment({
    number: installmentNumber,
    price: floatToMoney(rawInstallment.total_amount),
    paidPrice: floatToMoney(rawInstallment.paid_amount),
    outstandingPrice: floatToMoney(rawInstallment.amount_outstanding),
    selectedPrice: floatToMoney(rawInstallment.amount_outstanding),
    dueDate: rawInstallment.due_date
  });
}

Installment.fromAppserver = buildInstallmentFromAppserver;
export default Installment;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/OtherPayment/Installment.js